import { useState } from "react";

var C = {
  bg:"#0F1117", surface:"#1A1D27", surfaceHi:"#1E2230", inputBg:"#13151F",
  border:"#2E3248", accent:"#F5A623", accentDim:"rgba(245,166,35,0.1)",
  blue:"#4A90D9", blueDim:"rgba(74,144,217,0.1)", teal:"#38BFA1",
  success:"#4CAF6E", successDim:"rgba(76,175,110,0.1)", danger:"#E05C5C",
  purple:"#9B72D0", text:"#E8EAF0", dim:"#9AA0C0", muted:"#6B7094",
};
var FM = { fontFamily:"'DM Mono','Courier New',monospace" };
var lbl = { fontSize:10, color:"#6B7094", letterSpacing:"0.12em", textTransform:"uppercase", fontWeight:600, fontFamily:"'DM Mono','Courier New',monospace" };
var inp = { background:"#13151F", border:"1px solid #2E3248", borderRadius:8, padding:"12px 14px", color:"#E8EAF0", fontSize:13, fontFamily:"'DM Mono','Courier New',monospace", outline:"none", width:"100%", boxSizing:"border-box" };

var INDUSTRIES = [
  { value:"landscaping", label:"Landscaping & Grounds",     icon:"\uD83C\uDF3F" },
  { value:"excavation",  label:"Excavation & Construction", icon:"\uD83C\uDFD7" },
  { value:"agriculture", label:"Farm & Ranch",              icon:"\uD83C\uDF3E" },
  { value:"rental",      label:"Equipment Rental",          icon:"\uD83D\uDD11" },
  { value:"other",       label:"Other",                     icon:"\uD83D\uDD27" },
,
  {value:"ev",          label:"Electric Equipment",    icon:"\u26A1",  sub:"Electric mowers / equipment" },
];

var FLEET_SIZES = [
  { value:"1-5",   label:"1 - 5",   sub:"Just getting started" },
  { value:"6-15",  label:"6 - 15",  sub:"Growing operation" },
  { value:"16-50", label:"16 - 50", sub:"Established fleet" },
  { value:"50+",   label:"50+",     sub:"Large operation" },
];

var EQ_TYPES = [
  { value:"vehicle",      label:"Vehicle",         icon:"\uD83D\uDE97" },
  { value:"heavy",        label:"Heavy Equipment", icon:"\uD83C\uDFD7" },
  { value:"lawn",         label:"Lawn & Grounds",  icon:"\uD83C\uDF3F" },
  { value:"agricultural", label:"Agricultural",    icon:"\uD83D\uDE9C" },
  { value:"genpump",      label:"Gen / Pump",      icon:"\u26A1" },
  { value:"smalleq",      label:"Small Equip.",    icon:"\uD83E\uDE9A" },
  { value:"trailer",      label:"Trailer",         icon:"\uD83D\uDE9B" },
  { value:"other",        label:"Other",           icon:"\uD83D\uDD27" },
];

// Spec DB for onboarding autofill
var ONBOARD_SPEC_DB = [
  {make:"Cub Cadet",   model:"ZS1 60",  type:"lawn",        eot:"SAE 10W-30",eoq:"1.7 qt",ofpn:"490-200-0011",afpn:"490-200-0020",sp:"RJ19LM"},
  {make:"Cub Cadet",   model:"ZS1 54",  type:"lawn",        eot:"SAE 10W-30",eoq:"1.7 qt",ofpn:"490-200-0011",afpn:"490-200-0020",sp:"RJ19LM"},
  {make:"John Deere",  model:"Z960M",   type:"lawn",        eot:"SAE 10W-30",eoq:"2.0 qt",ofpn:"GY20577",     afpn:"M131802",     sp:"RC12YC"},
  {make:"John Deere",  model:"Z930M",   type:"lawn",        eot:"SAE 10W-30",eoq:"2.0 qt",ofpn:"GY20577",     afpn:"M131802",     sp:"RC12YC"},
  {make:"Bobcat",      model:"S650",    type:"heavy",       eot:"15W-40",    eoq:"8.0 qt",ofpn:"6667352",     afpn:"7023674",     hot:"ISO 46 AW",hoq:"16 gal"},
  {make:"Bobcat",      model:"S770",    type:"heavy",       eot:"15W-40",    eoq:"9.0 qt",ofpn:"6667352",     afpn:"7023674",     hot:"ISO 46 AW",hoq:"20 gal"},
  {make:"Bobcat",      model:"T590",    type:"heavy",       eot:"15W-40",    eoq:"8.0 qt",ofpn:"6667352",     afpn:"7023674",     hot:"ISO 46 AW",hoq:"16 gal"},
  {make:"Caterpillar", model:"299D3",   type:"heavy",       eot:"15W-40",    eoq:"10.0 qt",ofpn:"1R-0716",   afpn:"600-185-5100",hot:"Cat HYDO", hoq:"30 gal"},
  {make:"Kubota",      model:"L3901",   type:"agricultural",eot:"15W-40",    eoq:"6.3 qt",ofpn:"HH150-32430",afpn:"6C090-99280", hot:"Kubota UDT2",hoq:"13 gal"},
  {make:"Kubota",      model:"BX23S",   type:"agricultural",eot:"10W-40",    eoq:"3.7 qt",ofpn:"HH160-32430",afpn:"6C090-99280", hot:"Kubota UDT2",hoq:"5 gal"},
  {make:"Honda",       model:"GX390",   type:"genpump",     eot:"SAE 10W-30",eoq:"1.1 qt",afpn:"17210-Z0J-010",sp:"BPR6ES"},
  {make:"Kawasaki",    model:"FX730V",  type:"lawn",        eot:"SAE 10W-30",eoq:"1.8 qt",ofpn:"49065-7007", afpn:"11029-7032",  sp:"RC12YC"},
];

var DEFAULT_IV = {
  vehicle:      [
    {task:"Oil & Filter Change",         h:5000,  d:false},{task:"Tire Rotation",             h:7500,  d:false},
    {task:"Brake Inspection",            h:15000, d:false},{task:"Cabin Air Filter Clean",     h:5000,  d:false},
    {task:"Cabin Air Filter Replace",    h:7500,  d:false},{task:"Engine Air Filter Clean",    h:1000,  d:false},
    {task:"Engine Air Filter Replace",   h:10000, d:false},
  ],
  heavy:        [
    {task:"Engine Oil & Filter",         h:250,   d:false},{task:"Hydraulic Fluid Check",      h:500,   d:false},
    {task:"Greasing / Lubrication",      h:50,    d:false},{task:"Engine Air Filter Replace",  h:500,   d:false},
    {task:"Cabin Filter Replace",        h:500,   d:false},
  ],
  lawn:         [
    {task:"Engine Oil Change",           h:100,   d:false},{task:"Air Filter Replace",         h:500,   d:false},
    {task:"Spark Plug Replace",          h:500,   d:false},{task:"Hydraulic Fluid Change",     h:500,   d:false},
    {task:"Spark Arrestor Clean",        h:100,   d:false},{task:"Belt Inspection",            h:100,   d:false},
    {task:"Greasing / Lubrication",      h:100,   d:false},
  ],
  agricultural: [
    {task:"Engine Oil & Filter",         h:250,   d:false},{task:"Hydraulic Fluid Check",      h:500,   d:false},
    {task:"Greasing / Lubrication",      h:50,    d:false},
  ],
  genpump:      [
    {task:"Engine Oil & Filter",         h:100,   d:false},{task:"Air Filter Replace",         h:200,   d:false},
    {task:"Spark Plug Replace",          h:300,   d:false},{task:"Spark Arrestor Clean",       h:100,   d:false},
  ],
  trailer:      [
    {task:"Check Lights & Wiring",       h:7,     d:true}, {task:"Check Brakes",               h:7,     d:true},
    {task:"Check Ramp Hinges",           h:7,     d:true}, {task:"Check Tire Pressure & Tread",h:7,     d:true},
    {task:"Wheel Bearing Inspection",    h:365,   d:true}, {task:"Decking Inspection",         h:365,   d:true},
  ],
  smalleq:      [
    {task:"Air Filter Replace",          h:30,    d:true}, {task:"Spark Plug Replace",         h:90,    d:true},
    {task:"Spark Arrestor Clean",        h:30,    d:true}, {task:"Fuel Filter Replace",        h:90,    d:true},
    {task:"2-Stroke Oil Stock Check",    h:7,     d:true}, {task:"Bar & Chain Oil Check",      h:7,     d:true},
    {task:"Annual Inspection",           h:365,   d:true},
  ],
  other:        [
    {task:"General Inspection",          h:250,   d:false},{task:"Oil Change",                 h:100,   d:false},
    {task:"Annual Safety Check",         h:365,   d:true},
  ],
  ev:           [
    {task:"Battery Health Check",        h:90,    d:true}, {task:"Battery Terminal Cleaning",  h:180,   d:true},
    {task:"Charging Port & Cable Check", h:90,    d:true}, {task:"Tire Pressure Check",        h:30,    d:true},
    {task:"Grease Fittings",             h:100,   d:false},{task:"Brake Inspection",           h:200,   d:false},
    {task:"Annual Full Inspection",      h:365,   d:true},
  ],
};

var TUTORIALS = [
  { icon:"\uD83D\uDCCB", title:"Log Daily Hours",       body:"Tap Log Entry from your dashboard. Enter current hours or mileage, add a fuel note, and any observations. Takes 30 seconds.", color:"#F5A623" },
  { icon:"\uD83D\uDD27", title:"Mark Service Complete", body:"When maintenance is done, find the interval in the equipment profile or alerts screen and tap Done. It resets the counter and creates a service record automatically.", color:"#4CAF6E" },
  { icon:"\uD83D\uDEA8", title:"Service Requests",      body:"Crew can submit a service request from their dashboard or any equipment profile. You see it instantly in your admin dashboard with priority level.", color:"#9B72D0" },
  { icon:"\uD83D\uDCCA", title:"Read Your Dashboard",   body:"Down equipment is at the top in red. Overdue alerts below that. Warnings in amber. Green means you are ahead of schedule. Everything is a link.", color:"#4A90D9" },
];

function genId() { return "ch_"+Date.now()+"_"+Math.random().toString(36).slice(2,7); }

function buildIvs(type, usage, lastSvcUsage) {
  var base = (lastSvcUsage!==undefined && lastSvcUsage!==null && String(lastSvcUsage).trim()!=="") ? (parseFloat(lastSvcUsage)||0) : (parseFloat(usage)||0);
  var templates = DEFAULT_IV[type] || DEFAULT_IV.other;
  return templates.map(function(tmpl) {
    return { id:genId(), task:tmpl.task, intervalHours:tmpl.h, lastDoneHours:tmpl.d?0:base, timeUnit:tmpl.d?"days":"usage", alertMode:"inapp" };
  });
}

function makeEq(type, name, make, model, year, usage, unitId, subtype, vin, serial, lastSvcDate, lastSvcUsage, lastSvcNotes) {
  return { id:genId(), name:name.trim(), type:type, make:make.trim(), model:model.trim(), year:year.trim(), usesMiles:type==="vehicle", totalUsage:parseFloat(usage)||0, status:"active", outOfService:null, vin:(vin||"").trim(), serialNumber:(serial||"").trim(), unitId:(unitId||"|").trim(), subtype:(subtype||""), engineOilType:"", engineOilQty:"", oilFilterPN:"", airFilterPN:"", fuelFilterPN:"", sparkPlug:"", tireSize:"", hydraulicOilType:"", hydraulicOilQty:"", lastServiceDate:lastSvcDate||new Date().toISOString().split("T")[0], lastServiceUsage:parseFloat(lastSvcUsage)||0, lastServiceNotes:(lastSvcNotes||"").trim(), customParts:[], maintenanceIntervals:buildIvs(type,usage,lastSvcUsage), warranty:null };
}

function PBar(props) {
  return (
    <div style={{ width:"100%", height:3, background:"#2E3248", borderRadius:2, overflow:"hidden" }}>
      <div style={{ height:3, background:"#F5A623", width:((props.step/props.total)*100)+"%", borderRadius:2, transition:"width 0.4s ease" }} />
    </div>
  );
}

function Hint(props) {
  return (
    <div style={{ background:"rgba(74,144,217,0.1)", border:"1px solid #4A90D9", borderRadius:8, padding:"10px 14px", display:"flex", gap:10, alignItems:"flex-start" }}>
      <span style={{ fontSize:14, flexShrink:0 }}>{"\u2139\uFE0F"}</span>
      <div style={{ fontSize:11, color:"#9AA0C0", lineHeight:1.6, fontFamily:"'DM Mono','Courier New',monospace" }}>{props.text}</div>
    </div>
  );
}


// ─── CAMERA SCAN SHEET (ONBOARDING) ──────────────────────────────────────────

function CameraScanSheetOnboard(props) {
  var mode = props.mode || "vin";
  var onResult = props.onResult || function(){};
  var onClose = props.onClose || function(){};
  var cs1=useState(null);   var imgData=cs1[0]; var setImgData=cs1[1];
  var cs2=useState("idle"); var status=cs2[0];  var setStatus=cs2[1];
  var cs3=useState(null);   var result=cs3[0];  var setResult=cs3[1];
  var cs4=useState(null);   var error=cs4[0];   var setError=cs4[1];

  var titles  = { vin:"Scan VIN", serial:"Scan Serial Number", hours:"Scan Hour Meter" };
  var hints   = {
    vin:"Point at the VIN plate on the dashboard, door jamb, or windshield. All 17 characters must be visible.",
    serial:"Point at the serial number plate on the frame, engine, or data tag.",
    hours:"Point at the hour meter display. Make sure the digits are clear and well-lit."
  };
  var prompts = {
    vin:"Look at this image and find the VIN (Vehicle Identification Number), a 17-character alphanumeric code. Return ONLY the VIN characters with no spaces or explanation. If unclear, return NOTFOUND.",
    serial:"Look at this image and find the serial number (may be labeled S/N, SN, Serial, or Serial No). Return ONLY the serial number characters. If unclear, return NOTFOUND.",
    hours:"Look at this image and find the hour meter reading showing total engine hours. Return ONLY the numeric value. If unclear, return NOTFOUND."
  };

  function handleFile(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function(ev) {
      var data = ev.target.result;
      setImgData(data); setStatus("scanning"); setError(null); setResult(null);
      var base64 = data.split(",")[1];
      var mediaType = data.split(";")[0].split(":")[1] || "image/jpeg";
      fetch("https://api.anthropic.com/v1/messages", {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          model:"claude-sonnet-4-20250514", max_tokens:100,
          messages:[{ role:"user", content:[
            {type:"image", source:{type:"base64", media_type:mediaType, data:base64}},
            {type:"text",  text:prompts[mode]}
          ]}]
        })
      })
      .then(function(r){ return r.json(); })
      .then(function(d){
        var text = d.content && d.content[0] && d.content[0].text;
        if (!text || text.trim().toUpperCase()==="NOTFOUND" || !text.trim()) {
          setStatus("error");
          setError("Couldn't read the "+(mode==="hours"?"hour meter":mode==="vin"?"VIN":"serial number")+" clearly. Try better lighting or a closer shot.");
        } else {
          var val = mode==="hours" ? text.trim().replace(/[^0-9.]/g,"") : text.trim().replace(/\s/g,"").toUpperCase();
          setResult(val); setStatus("done");
        }
      })
      .catch(function(){ setStatus("error"); setError("Scan failed. Check your connection and try again."); });
    };
    reader.readAsDataURL(file);
  }

  function retake() { setImgData(null); setStatus("idle"); setResult(null); setError(null); }

  var surface = "#1A1D27"; var border = "#2E3248"; var accent = "#F5A623";
  var danger = "#E05C5C"; var success = "#4CAF6E"; var dim = "#9AA0C0"; var muted = "#6B7094";
  var text = "#E8EAF0"; var inputBg = "#13151F";
  var fm = {fontFamily:"'DM Mono','Courier New',monospace"};

  return (
    <div style={{position:"fixed",top:0,right:0,bottom:0,left:0,background:"rgba(0,0,0,0.92)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:500}} onClick={onClose}>
      <div style={{background:surface,border:"1px solid "+border,borderRadius:"16px 16px 0 0",width:"100%",maxWidth:480,maxHeight:"90vh",display:"flex",flexDirection:"column",paddingBottom:28}} onClick={function(e){e.stopPropagation();}}>
        <div style={{width:36,height:4,background:border,borderRadius:2,margin:"12px auto 0",flexShrink:0}} />
        <div style={{padding:"14px 16px 12px",borderBottom:"1px solid "+border,flexShrink:0}}>
          <div style={{fontSize:11,fontWeight:700,color:accent,letterSpacing:"0.18em",textTransform:"uppercase",...fm}}>{titles[mode]}</div>
          <div style={{fontSize:11,color:dim,marginTop:4,lineHeight:1.5}}>{hints[mode]}</div>
        </div>
        <div style={{overflowY:"auto",flex:1,padding:16}}>
          {status==="idle" && (
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              <label style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",background:inputBg,border:"2px dashed "+border,borderRadius:14,padding:"40px 20px",cursor:"pointer",gap:12}}>
                <div style={{fontSize:48}}>{"📷"}</div>
                <div style={{fontSize:13,fontWeight:700,color:text,...fm}}>Take a Photo</div>
                <div style={{fontSize:11,color:muted,textAlign:"center"}}>Tap to open camera or choose from library</div>
                <input type="file" accept="image/*" capture="environment" onChange={handleFile} style={{display:"none"}} />
              </label>
              <div style={{background:"rgba(245,166,35,0.08)",border:"1px solid "+accent,borderRadius:10,padding:"10px 14px",fontSize:11,color:accent,lineHeight:1.6}}>
                {"💡 Tips: Good lighting, fill the frame, avoid glare."}
              </div>
            </div>
          )}
          {status==="scanning" && (
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:16,padding:"20px 0"}}>
              {imgData && <img src={imgData} alt="scan" style={{width:"100%",maxHeight:240,objectFit:"contain",borderRadius:10}} />}
              <div style={{fontSize:13,color:accent,...fm,fontWeight:700}}>Reading image...</div>
              <div style={{fontSize:11,color:muted}}>Claude is analyzing your photo</div>
            </div>
          )}
          {status==="error" && (
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              {imgData && <img src={imgData} alt="scan" style={{width:"100%",maxHeight:200,objectFit:"contain",borderRadius:10,opacity:0.6}} />}
              <div style={{background:"rgba(224,92,92,0.1)",border:"1px solid "+danger,borderRadius:10,padding:"12px 14px",fontSize:12,color:danger,lineHeight:1.6}}>{error}</div>
              <button onClick={retake} style={{width:"100%",background:"rgba(245,166,35,0.1)",border:"1px solid "+accent,borderRadius:10,color:accent,fontSize:12,...fm,fontWeight:700,padding:12,cursor:"pointer",textTransform:"uppercase",letterSpacing:"0.08em"}}>Try Again</button>
            </div>
          )}
          {status==="done" && result && (
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              {imgData && <img src={imgData} alt="scan" style={{width:"100%",maxHeight:200,objectFit:"contain",borderRadius:10}} />}
              <div style={{background:"rgba(76,175,110,0.1)",border:"1px solid "+success,borderRadius:12,padding:"16px 14px"}}>
                <div style={{fontSize:10,color:success,fontWeight:700,letterSpacing:"0.15em",textTransform:"uppercase",marginBottom:8}}>
                  {mode==="vin"?"VIN Detected":mode==="serial"?"Serial Detected":"Hours Detected"}
                </div>
                <div style={{fontSize:20,fontWeight:700,color:text,letterSpacing:"0.1em",...fm}}>{result}</div>
              </div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={retake} style={{flex:1,background:"none",border:"1px solid "+border,borderRadius:10,color:muted,fontSize:12,...fm,padding:12,cursor:"pointer"}}>Retake</button>
                <button onClick={function(){ onResult(result); onClose(); }} style={{flex:2,background:accent,border:"none",borderRadius:10,color:"#0F1117",fontSize:12,...fm,fontWeight:700,padding:12,cursor:"pointer",textTransform:"uppercase",letterSpacing:"0.08em"}}>{"Use This →"}</button>
              </div>
            </div>
          )}
        </div>
        <div style={{padding:"0 16px",flexShrink:0}}>
          <button onClick={onClose} style={{width:"100%",background:"none",border:"1px solid "+border,borderRadius:10,color:muted,fontSize:12,...fm,padding:12,cursor:"pointer",textTransform:"uppercase",letterSpacing:"0.08em"}}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default function OnboardingScreen(props) {
  var onComplete = props.onComplete || function(){};
  var user = props.user || {};
  // Plans that support crew features
  var CREW_PLANS = ["captain","pro"];
  var userPlan = user.plan || "free";
  var hasCrew = CREW_PLANS.indexOf(userPlan) >= 0;

  var s1=useState(1);  var step=s1[0];      var setStep=s1[1];
  var s2=useState(user.company||""); var company=s2[0];   var setCompany=s2[1];
  var s3=useState(""); var industry=s3[0];  var setIndustry=s3[1];
  var s4=useState(""); var fsize=s4[0];     var setFsize=s4[1];
  var s5=useState([]); var fleet=s5[0];     var setFleet=s5[1];
  var s6=useState(""); var eqType=s6[0];    var setEqType=s6[1];
  var s7=useState(""); var eqName=s7[0];    var setEqName=s7[1];
  var s8=useState(""); var eqMake=s8[0];    var setEqMake=s8[1];
  var s9=useState(""); var eqModel=s9[0];   var setEqModel=s9[1];
  var s10=useState(""); var eqYear=s10[0];  var setEqYear=s10[1];
  var s11=useState(""); var eqUsage=s11[0]; var setEqUsage=s11[1];
  var s12=useState([]); var ivs=s12[0];     var setIvs=s12[1];
  var s13=useState(""); var cName=s13[0];   var setCName=s13[1];
  var s14=useState(""); var cEmail=s14[0];  var setCEmail=s14[1];
  var s15=useState([]); var crew=s15[0];    var setCrew=s15[1];
  var s16=useState(0);  var slide=s16[0];   var setSlide=s16[1];
  var s17=useState(""); var eqUnitId=s17[0]; var setEqUnitId=s17[1];
  var s18=useState(""); var eqSubtype=s18[0]; var setEqSubtype=s18[1];
  var s23=useState(""); var eqVinSerial=s23[0]; var setEqVinSerial=s23[1];
  var s24=useState(null); var eqAutoFilled=s24[0]; var setEqAutoFilled=s24[1];
  var s25=useState(false); var eqLookupLoading=s25[0]; var setEqLookupLoading=s25[1];
  var s26=useState(null); var eqLookupErr=s26[0]; var setEqLookupErr=s26[1];
  var s27=useState(""); var eqVin=s27[0]; var setEqVin=s27[1];
  var s28=useState(""); var eqSerial=s28[0]; var setEqSerial=s28[1];
  var s29=useState(""); var eqLastSvcDate=s29[0]; var setEqLastSvcDate=s29[1];
  var s30=useState(""); var eqLastSvcUsage=s30[0]; var setEqLastSvcUsage=s30[1];
  var s31=useState(""); var eqLastSvcNotes=s31[0]; var setEqLastSvcNotes=s31[1];
  var s32=useState(null); var scanMode=s32[0]; var setScanMode=s32[1];
  var s19=useState(false); var showBatch=s19[0]; var setShowBatch=s19[1];
  var s20=useState(""); var lastMake=s20[0]; var setLastMake=s20[1];
  var s21=useState(""); var lastModel=s21[0]; var setLastModel=s21[1];
  var s22=useState(""); var lastType=s22[0]; var setLastType=s22[1];

  function next() {
    setStep(function(s) {
      // Skip crew step (5) for Free and One Man Band plans
      if (s === 4 && !hasCrew) return 6;
      return s + 1;
    });
  }
  function back() {
    setStep(function(s) {
      // Skip crew step (5) going backwards too
      if (s === 6 && !hasCrew) return 4;
      return Math.max(1, s - 1);
    });
  }

  function clearForm(keepType) { if (!keepType) setEqType(""); setEqName(""); setEqMake(""); setEqModel(""); setEqYear(""); setEqUsage(""); setEqUnitId(""); setEqSubtype(""); setEqVinSerial(""); setEqAutoFilled(null); setEqLookupErr(null); setEqVin(""); setEqSerial(""); setEqLastSvcDate(""); setEqLastSvcUsage(""); setEqLastSvcNotes(""); setShowBatch(false); }

  function lookupVin() {
    var v = eqVinSerial.trim().toUpperCase();
    if (v.length < 11) { setEqLookupErr("Enter at least 11 characters of the VIN."); return; }
    setEqLookupLoading(true); setEqLookupErr(null);
    fetch("/.netlify/functions/vin-lookup?vin="+v)
      .then(function(r){ return r.json(); })
      .then(function(data){
        setEqLookupLoading(false);
        var r = data.Results && data.Results[0];
        if (!r || !r.Make || r.Make === "") { setEqLookupErr("VIN not found. Fill in manually below."); return; }
        var mk = r.Make ? r.Make.charAt(0).toUpperCase()+r.Make.slice(1).toLowerCase() : "";
        setEqVin(v); setEqMake(mk); setEqModel(r.Model||""); setEqYear(r.ModelYear||"");
        if (!eqName.trim()) setEqName(mk+" "+(r.Model||"")+" #1");
        setEqAutoFilled(mk+" "+(r.Model||"")+" "+(r.ModelYear||""));
      })
      .catch(function(){ setEqLookupLoading(false); setEqLookupErr("Lookup failed. Fill in manually."); });
  }

  function lookupSerial() {
    var q = eqVinSerial.trim().toUpperCase();
    setEqSerial(q); setEqLookupErr(null);
    var matched = null;
    ONBOARD_SPEC_DB.forEach(function(spec) {
      if (matched) return;
      var words = q.replace(/[^A-Z0-9]/g," ").split(" ").filter(function(w){ return w.length>1; });
      var mk = spec.make.toUpperCase(); var md = spec.model.toUpperCase();
      var mkHit = words.some(function(w){ return mk.indexOf(w)>=0||w.indexOf(mk.split(" ")[0])>=0; });
      var mdHit = words.some(function(w){ return md.indexOf(w)>=0||w===md; });
      if (mkHit && mdHit) matched = spec;
    });
    if (matched) {
      setEqMake(matched.make); setEqModel(matched.model);
      setEqAutoFilled(matched.make+" "+matched.model);
    }
  }

  function saveAndAnother() {
    if (!eqType||!eqName.trim()) return;
    setFleet(function(f){ return f.concat([makeEq(eqType,eqName,eqMake,eqModel,eqYear,eqUsage,eqUnitId,eqSubtype,eqVin,eqSerial,eqLastSvcDate,eqLastSvcUsage,eqLastSvcNotes)]); });
    setLastType(eqType); setLastMake(eqMake); setLastModel(eqModel);
    setShowBatch(true);
    clearForm(false);
    setEqType(eqType);
  }

  function saveAndNext() {
    var lastEq = (eqType&&eqName.trim()) ? [makeEq(eqType,eqName,eqMake,eqModel,eqYear,eqUsage,eqUnitId,eqSubtype,eqVin,eqSerial,eqLastSvcDate,eqLastSvcUsage,eqLastSvcNotes)] : [];
    var all = fleet.concat(lastEq);
    if (all.length===0) { next(); return; }
    // Build interval toggles for the last piece
    var templates = DEFAULT_IV[eqType||"other"] || DEFAULT_IV.other;
    var built = templates.map(function(tmpl) {
      var ivBase=(String(eqLastSvcUsage).trim()!=="")?(parseFloat(eqLastSvcUsage)||0):(parseFloat(eqUsage)||0);
      return { id:genId(), task:tmpl.task, intervalHours:tmpl.h, lastDoneHours:tmpl.d?0:ivBase, timeUnit:tmpl.d?"days":"usage", alertMode:"inapp", _on:true };
    });
    setIvs(built);
    next();
  }

  function toggleIv(id) { setIvs(ivs.map(function(iv){ return iv.id===id?Object.assign({},iv,{_on:!iv._on}):iv; })); }

  function addCrew() {
    if (!cName.trim()) return;
    setCrew(crew.concat([{id:genId(),name:cName.trim(),email:cEmail.trim()}]));
    setCName(""); setCEmail("");
  }

  function finish() {
    var finalIvs = ivs.filter(function(iv){ return iv._on; }).map(function(iv){ var c=Object.assign({},iv); delete c._on; return c; });
    var lastEq = (eqType&&eqName.trim()) ? [Object.assign({},makeEq(eqType,eqName,eqMake,eqModel,eqYear,eqUsage,eqUnitId,eqSubtype,eqVin,eqSerial,eqLastSvcDate,eqLastSvcUsage,eqLastSvcNotes),{maintenanceIntervals:finalIvs})] : [];
    onComplete({ company:company.trim(), industry:industry, fleetSize:fsize, equipment:fleet.concat(lastEq), crew:crew });
  }

  var totalEq = fleet.length + (eqName.trim()&&ivs.length>0?1:0);
  var totalIvs = ivs.filter(function(iv){ return iv._on; }).length + fleet.reduce(function(sum,eq){ return sum+eq.maintenanceIntervals.length; },0);
  var css = "@import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&display=swap'); *{box-sizing:border-box;margin:0;padding:0;} input:focus{border-color:#F5A623!important;outline:none;} ::-webkit-scrollbar{width:4px;} ::-webkit-scrollbar-thumb{background:#2E3248;border-radius:2px;} button:hover{opacity:0.88;}";

  return (
    <div style={{ ...FM, background:"#0F1117", minHeight:"100vh", color:"#E8EAF0", display:"flex", flexDirection:"column", alignItems:"center" }}>
      <style>{css}</style>
      <div style={{ width:"100%", maxWidth:480, display:"flex", flexDirection:"column", minHeight:"100vh" }}>

        {/* STEP 1 — WELCOME */}
        {step===1 && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"40px 24px", textAlign:"center" }}>
            <div style={{ width:72, height:72, background:"#F5A623", borderRadius:16, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:28, boxShadow:"0 8px 32px rgba(245,166,35,0.3)" }}>
              <span style={{ ...FM, fontWeight:700, color:"#0F1117", fontSize:18, letterSpacing:"0.05em" }}>CH</span>
            </div>
            <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:10 }}>Welcome to ChoreHabit</div>
            <div style={{ fontSize:28, fontWeight:700, lineHeight:1.2, marginBottom:6 }}>Your chores.<br/>Your habit.</div>
            <div style={{ fontSize:12, color:"#F5A623", fontWeight:700, letterSpacing:"0.12em", textTransform:"uppercase", marginBottom:16 }}>Never fall behind.</div>
            <div style={{ fontSize:14, color:"#9AA0C0", lineHeight:1.7, marginBottom:40, maxWidth:340 }}>Takes about 5 minutes. You can skip anything and come back later from your dashboard.</div>
            <div style={{ display:"flex", flexDirection:"column", gap:12, width:"100%", maxWidth:360 }}>
              {[{i:"\uD83D\uDD27",t:"Track maintenance for every piece of equipment"},{i:"\uD83D\uDCCB",t:"Log hours and service history from your phone"},{i:"\uD83D\uDEA8",t:"Get smart alerts before things break down"},{i:"\uD83D\uDC65",t:"Keep your whole crew on the same page"}].map(function(item) {
                return (
                  <div key={item.t} style={{ display:"flex", alignItems:"center", gap:12, background:"#1A1D27", border:"1px solid #2E3248", borderRadius:10, padding:"12px 16px" }}>
                    <span style={{ fontSize:20, flexShrink:0 }}>{item.i}</span>
                    <span style={{ fontSize:12, color:"#9AA0C0", lineHeight:1.5 }}>{item.t}</span>
                  </div>
                );
              })}
            </div>
            <button onClick={next} style={{ marginTop:40, width:"100%", maxWidth:360, background:"#F5A623", border:"none", borderRadius:12, color:"#0F1117", fontSize:14, ...FM, fontWeight:700, padding:16, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.1em" }}>Get Started</button>
            <div style={{ marginTop:16, fontSize:11, color:"#6B7094" }}>Already have an account? <span style={{ color:"#F5A623", cursor:"pointer" }}>Sign in</span></div>
          </div>
        )}

        {/* STEP 2 — COMPANY */}
        {step===2 && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", padding:"24px 24px 100px" }}>
            <PBar step={1} total={7} />
            <div style={{ marginTop:28, marginBottom:28 }}>
              <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:10 }}>Step 1 of 6</div>
              <div style={{ fontSize:24, fontWeight:700, lineHeight:1.2, marginBottom:8 }}>Tell us about your operation</div>
              <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.6 }}>This helps us set up the right defaults for your fleet.</div>
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:20 }}>
              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                <label style={lbl}>Company or Operation Name *</label>
                <input style={inp} placeholder="e.g. Green Ridge Lawn Care" value={company} onChange={function(e){ setCompany(e.target.value); }} />
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                <label style={lbl}>What kind of operation? *</label>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
                  {INDUSTRIES.map(function(ind) {
                    var sel=industry===ind.value;
                    return (
                      <div key={ind.value} onClick={function(){ setIndustry(ind.value); }} style={{ background:sel?"rgba(245,166,35,0.1)":"#1A1D27", border:"1.5px solid "+(sel?"#F5A623":"#2E3248"), borderRadius:10, padding:"12px 14px", cursor:"pointer", display:"flex", alignItems:"center", gap:10 }}>
                        <span style={{ fontSize:20 }}>{ind.icon}</span>
                        <span style={{ fontSize:11, fontWeight:sel?700:400, color:sel?"#F5A623":"#9AA0C0", lineHeight:1.3 }}>{ind.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                <label style={lbl}>How many pieces of equipment?</label>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:8 }}>
                  {FLEET_SIZES.map(function(fs) {
                    var sel=fsize===fs.value;
                    return (
                      <div key={fs.value} onClick={function(){ setFsize(fs.value); }} style={{ background:sel?"rgba(245,166,35,0.1)":"#1A1D27", border:"1.5px solid "+(sel?"#F5A623":"#2E3248"), borderRadius:10, padding:"12px 14px", cursor:"pointer" }}>
                        <div style={{ fontSize:16, fontWeight:700, color:sel?"#F5A623":"#E8EAF0" }}>{fs.label}</div>
                        <div style={{ fontSize:10, color:"#6B7094", marginTop:2 }}>{fs.sub}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* STEP 3 — ADD EQUIPMENT (MULTIPLE) */}
        {step===3 && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", padding:"24px 24px 120px" }}>
            <PBar step={2} total={7} />
            <div style={{ marginTop:28, marginBottom:20 }}>
              <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:10 }}>Step 2 of 6</div>
              <div style={{ fontSize:24, fontWeight:700, lineHeight:1.2, marginBottom:8 }}>{fleet.length===0?"Add your equipment":"Add more equipment"}</div>
              <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.6 }}>Add your whole fleet now or skip and add more from your dashboard later.</div>
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>

              {/* Fleet already added */}
              {fleet.length>0 && (
                <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                  <div style={{ fontSize:10, color:"#4CAF6E", letterSpacing:"0.12em", textTransform:"uppercase", fontWeight:700, ...FM, marginBottom:2 }}>
                    {fleet.length} piece{fleet.length!==1?"s":""} added
                  </div>
                  {fleet.map(function(eq) {
                    var tp=EQ_TYPES.filter(function(x){ return x.value===eq.type; })[0];
                    return (
                      <div key={eq.id} style={{ background:"rgba(76,175,110,0.1)", border:"1px solid #4CAF6E", borderRadius:10, padding:"10px 14px", display:"flex", alignItems:"center", gap:10 }}>
                        <span style={{ fontSize:20, flexShrink:0 }}>{tp?tp.icon:"\uD83D\uDD27"}</span>
                        <div style={{ flex:1 }}>
                          <div style={{ fontSize:12, fontWeight:700 }}>{eq.name}</div>
                          <div style={{ fontSize:10, color:"#6B7094", marginTop:1 }}>{[eq.make,eq.model,eq.year].filter(Boolean).join(" ")}{eq.totalUsage>0?" -- "+eq.totalUsage+(eq.usesMiles?" mi":" hrs"):""}</div>
                        </div>
                        <button onClick={function(){ setFleet(fleet.filter(function(f){ return f.id!==eq.id; })); }} style={{ background:"none", border:"none", color:"#6B7094", fontSize:18, cursor:"pointer", lineHeight:1, padding:"0 4px" }}>x</button>
                      </div>
                    );
                  })}
                  <div style={{ display:"flex", alignItems:"center", gap:10, margin:"6px 0" }}>
                    <div style={{ flex:1, height:1, background:"#2E3248" }} />
                    <span style={{ fontSize:10, color:"#F5A623", ...FM, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.1em" }}>Add Another</span>
                    <div style={{ flex:1, height:1, background:"#2E3248" }} />
                  </div>
                </div>
              )}

              {/* Equipment type */}
              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                <label style={lbl}>Type of Equipment *</label>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8 }}>
                  {EQ_TYPES.map(function(tp) {
                    var sel=eqType===tp.value;
                    return (
                      <div key={tp.value} onClick={function(){ setEqType(tp.value); }} style={{ background:sel?"rgba(245,166,35,0.1)":"#1A1D27", border:"1.5px solid "+(sel?"#F5A623":"#2E3248"), borderRadius:10, padding:"12px 6px", display:"flex", flexDirection:"column", alignItems:"center", gap:5, cursor:"pointer" }}>
                        <span style={{ fontSize:22 }}>{tp.icon}</span>
                        <span style={{ fontSize:9, fontWeight:sel?700:400, color:sel?"#F5A623":"#9AA0C0", textAlign:"center", textTransform:"uppercase" }}>{tp.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Small equipment info card */}
              {eqType==="smalleq" && (
                <div style={{ background:"rgba(245,166,35,0.08)", border:"1px solid #F5A623", borderRadius:12, padding:"12px 14px" }}>
                  <div style={{ fontSize:12, fontWeight:700, color:"#F5A623", marginBottom:4 }}>Calendar-based tracking</div>
                  <div style={{ fontSize:11, color:"#9AA0C0", lineHeight:1.6 }}>Small equipment is tracked by days — not hours. Standard intervals for air filter, spark plug, spark arrestor, and fuel filter will be set up automatically.</div>
                </div>
              )}

              {/* VIN / Serial lookup — vehicles and equipment only */}
              {eqType && eqType!=="trailer" && eqType!=="smalleq" && eqType!=="other" && (
                <div style={{ background:"#1A1D27", border:"1px solid #2E3248", borderRadius:12, padding:"14px 16px", display:"flex", flexDirection:"column", gap:10 }}>
                  {scanMode && (
                    <CameraScanSheetOnboard
                      mode={scanMode}
                      onResult={function(val){
                        if (scanMode==="hours") { setEqUsage(val); }
                        else { setEqVinSerial(val); setEqLookupErr(null); setEqAutoFilled(null); }
                        setScanMode(null);
                      }}
                      onClose={function(){ setScanMode(null); }}
                    />
                  )}
                  <div style={{ fontSize:10, color:"#F5A623", fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase" }}>
                    {eqType==="vehicle" ? "VIN Lookup — auto-fills make, model, year" : "Search by make & model or serial number"}
                  </div>
                  {eqAutoFilled && (
                    <div style={{ background:"rgba(76,175,110,0.1)", border:"1px solid #4CAF6E", borderRadius:8, padding:"8px 12px", fontSize:11, color:"#4CAF6E" }}>
                      {"✓ Specs auto-filled for "+eqAutoFilled}
                    </div>
                  )}
                  <div style={{ display:"flex", gap:8 }}>
                    <input
                      style={{ ...inp, flex:1, borderColor:eqLookupErr?"#E05C5C":"#2E3248" }}
                      placeholder={eqType==="vehicle"?"1FTFW1ET5MFC12345":"e.g. Bobcat S650 or serial B3N416648"}
                      value={eqVinSerial}
                      onChange={function(e){ setEqVinSerial(e.target.value); setEqLookupErr(null); setEqAutoFilled(null); }}
                    />
                    <button onClick={function(){ setScanMode(eqType==="vehicle"?"vin":"serial"); }}
                      style={{ background:"rgba(245,166,35,0.1)", border:"1px solid #F5A623", borderRadius:8, color:"#F5A623", fontSize:18, padding:"0 12px", cursor:"pointer", flexShrink:0 }}>
                      {"📷"}
                    </button>
                    <button
                      onClick={eqType==="vehicle"?lookupVin:lookupSerial}
                      disabled={!eqVinSerial.trim()||eqLookupLoading}
                      style={{ background:eqVinSerial.trim()&&!eqLookupLoading?"#F5A623":"#1E2230", border:"none", borderRadius:8, color:eqVinSerial.trim()&&!eqLookupLoading?"#0F1117":"#6B7094", fontSize:11, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:"0 12px", cursor:eqVinSerial.trim()&&!eqLookupLoading?"pointer":"not-allowed", flexShrink:0, textTransform:"uppercase" }}
                    >
                      {eqLookupLoading?"...":"Look Up"}
                    </button>
                  </div>
                  {eqLookupErr && <div style={{ fontSize:11, color:"#E05C5C", fontFamily:"'DM Mono','Courier New',monospace" }}>{eqLookupErr}</div>}
                  <div style={{ fontSize:10, color:"#6B7094", fontFamily:"'DM Mono','Courier New',monospace" }}>
                    {eqType==="vehicle"?"Tap 📷 to scan VIN with camera, or type manually.":"Tap 📷 to scan serial number, or enter make and model."}
                  </div>
                </div>
              )}

              {/* Equipment details */}
              {eqType && (
                <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                  <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                    <label style={lbl}>Nickname or Name *</label>
                    <input style={inp} placeholder={eqType==="vehicle"?"e.g. Shop Truck, Big Blue F-250":eqType==="smalleq"?"e.g. Stihl MS 271 Chainsaw, Echo Trimmer":"e.g. Bobcat #1, Front Mower"} value={eqName} onChange={function(e){ setEqName(e.target.value); }} />
                    <div style={{ fontSize:10, color:"#6B7094", ...FM }}>Make it something your crew recognizes instantly.</div>
                  </div>
                  {eqType!=="smalleq" && (
                    <div style={{ display:"flex", gap:10 }}>
                      <div style={{ flex:1, display:"flex", flexDirection:"column", gap:6 }}><label style={lbl}>Make</label><input style={inp} placeholder="Ford" value={eqMake} onChange={function(e){ setEqMake(e.target.value); }} /></div>
                      <div style={{ flex:1, display:"flex", flexDirection:"column", gap:6 }}><label style={lbl}>Model</label><input style={inp} placeholder="F-250" value={eqModel} onChange={function(e){ setEqModel(e.target.value); }} /></div>
                      <div style={{ maxWidth:72, display:"flex", flexDirection:"column", gap:6 }}><label style={lbl}>Year</label><input style={inp} placeholder="2022" maxLength={4} value={eqYear} onChange={function(e){ setEqYear(e.target.value); }} /></div>
                    </div>
                  )}
                  {eqType!=="smalleq" && eqType!=="trailer" && (
                    <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                      <label style={lbl}>Current {eqType==="vehicle"?"Mileage (mi)":"Hours (hrs)"}</label>
                      <div style={{ display:"flex", gap:8 }}>
                        <input style={{ ...inp, flex:1 }} type="number" inputMode="numeric" placeholder="0" value={eqUsage} onChange={function(e){ setEqUsage(e.target.value); }} />
                        {eqType!=="vehicle" && (
                          <button onClick={function(){ setScanMode("hours"); }} style={{ background:"rgba(245,166,35,0.1)", border:"1px solid #F5A623", borderRadius:8, color:"#F5A623", fontSize:18, padding:"0 12px", cursor:"pointer", flexShrink:0 }}>{"📷"}</button>
                        )}
                      </div>
                      <Hint text={eqType==="vehicle"?"Check your odometer. This is the starting point for all service reminders.":"Tap 📷 to scan your hour meter, or enter manually."} />
                    </div>
                  )}
                  <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                    <label style={lbl}>Unit ID / Fleet Number <span style={{ color:"#6B7094", fontWeight:400 }}>(optional)</span></label>
                    <input style={inp} placeholder="e.g. Unit 4, Mower #2, #07" value={eqUnitId} onChange={function(e){ setEqUnitId(e.target.value); }} />
                    <div style={{ fontSize:10, color:"#6B7094", fontFamily:"'DM Mono','Courier New',monospace" }}>Your company fleet number. How your crew identifies this unit in the field.</div>
                  </div>
                  {/* Last service — sets baseline for interval tracking */}
                  <div style={{ background:"#1A1D27", border:"1px solid #2E3248", borderRadius:12, padding:"14px 16px", display:"flex", flexDirection:"column", gap:10 }}>
                    <div style={{ fontSize:10, color:"#4CAF6E", fontWeight:700, letterSpacing:"0.15em", textTransform:"uppercase", ...FM }}>Last Service <span style={{ color:"#6B7094", fontWeight:400, textTransform:"none", letterSpacing:0 }}>(optional)</span></div>
                    <div style={{ fontSize:11, color:"#6B7094", ...FM }}>Sets the baseline for maintenance interval tracking. Leave blank to start from today.</div>
                    <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
                      <label style={lbl}>Date of Last Service</label>
                      <input style={inp} type="date" value={eqLastSvcDate} onChange={function(e){ setEqLastSvcDate(e.target.value); }} />
                    </div>
                    {eqType!=="smalleq" && eqType!=="trailer" && (
                      <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
                        <label style={lbl}>Usage at Last Service ({eqType==="vehicle"?"mi":"hrs"})</label>
                        <input style={inp} type="number" inputMode="numeric" placeholder="0" value={eqLastSvcUsage} onChange={function(e){ setEqLastSvcUsage(e.target.value); }} />
                      </div>
                    )}
                    <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
                      <label style={lbl}>Notes (optional)</label>
                      <input style={inp} placeholder="What was done at last service..." value={eqLastSvcNotes} onChange={function(e){ setEqLastSvcNotes(e.target.value); }} />
                    </div>
                  </div>
                </div>
              )}

              {showBatch && fleet.length > 0 && (
                <div style={{ background:"rgba(245,166,35,0.08)", border:"1px solid #F5A623", borderRadius:12, padding:"14px 16px", marginTop:8 }}>
                  <div style={{ fontSize:12, fontWeight:700, color:"#F5A623", marginBottom:4, fontFamily:"'DM Mono','Courier New',monospace" }}>Add another {lastMake} {lastModel}?</div>
                  <div style={{ fontSize:11, color:"#9AA0C0", marginBottom:12, fontFamily:"'DM Mono','Courier New',monospace" }}>Make, model, year and intervals are pre-filled. Just change the nickname and hours.</div>
                  <div style={{ display:"flex", gap:8 }}>
                    <button onClick={function(){ setShowBatch(false); clearForm(false); }} style={{ flex:1, background:"none", border:"1px solid #2E3248", borderRadius:8, color:"#6B7094", fontSize:11, fontFamily:"'DM Mono','Courier New',monospace", padding:10, cursor:"pointer" }}>Different Unit</button>
                    <button onClick={function(){ setShowBatch(false); setEqMake(lastMake); setEqModel(lastModel); setEqType(lastType); }} style={{ flex:2, background:"#F5A623", border:"none", borderRadius:8, color:"#0F1117", fontSize:11, fontFamily:"'DM Mono','Courier New',monospace", fontWeight:700, padding:10, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>Yes, Same Type</button>
                  </div>
                </div>
              )}

              {!eqType && fleet.length===0 && (
                <div style={{ textAlign:"center", padding:"16px 0", color:"#6B7094", fontSize:13 }}>Select a type above to get started</div>
              )}
            </div>
          </div>
        )}

        {/* STEP 4 — MAINTENANCE INTERVALS */}
        {step===4 && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", padding:"24px 24px 100px" }}>
            <PBar step={3} total={hasCrew?7:6} />
            <div style={{ marginTop:28, marginBottom:20 }}>
              <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:10 }}>Step 3 of {hasCrew?"6":"5"}</div>
              <div style={{ fontSize:24, fontWeight:700, lineHeight:1.2, marginBottom:8 }}>Maintenance schedule</div>
              <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.6 }}>Standard intervals for {eqName||"your equipment"}. Toggle off anything that does not apply. Customize everything later.</div>
            </div>
            {fleet.length>0 && (
              <div style={{ background:"rgba(245,166,35,0.1)", border:"1px solid #F5A623", borderRadius:10, padding:"10px 14px", marginBottom:14, fontSize:11, color:"#F5A623", ...FM }}>
                {fleet.length} other piece{fleet.length!==1?"s":""} already added with default intervals.
              </div>
            )}
            <div style={{ flex:1, display:"flex", flexDirection:"column", gap:8 }}>
              {ivs.length===0 && <div style={{ textAlign:"center", padding:"30px 0", color:"#6B7094", fontSize:13 }}>No equipment to configure. Tap Back to add equipment.</div>}
              {ivs.map(function(iv) {
                var on=iv._on;
                return (
                  <div key={iv.id} onClick={function(){ toggleIv(iv.id); }} style={{ background:on?"#1A1D27":"#13151F", border:"1px solid "+(on?"#F5A623":"#2E3248"), borderRadius:12, padding:"14px 16px", cursor:"pointer", display:"flex", alignItems:"center", gap:12, opacity:on?1:0.5 }}>
                    <div style={{ width:24, height:24, borderRadius:6, border:"2px solid "+(on?"#F5A623":"#2E3248"), background:on?"#F5A623":"transparent", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      {on && <span style={{ color:"#0F1117", fontSize:14, fontWeight:900, lineHeight:1 }}>v</span>}
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13, fontWeight:700, color:on?"#E8EAF0":"#6B7094" }}>{iv.task}</div>
                      <div style={{ fontSize:11, color:"#6B7094", marginTop:2 }}>{iv.timeUnit==="days"?"Every "+(iv.intervalHours===7?"week":iv.intervalHours===365?"year":iv.intervalHours+" days"):"Every "+iv.intervalHours.toLocaleString()+" "+(eqType==="vehicle"?"mi":"hrs")}</div>
                    </div>
                  </div>
                );
              })}
              {ivs.length>0 && (
                <div style={{ display:"flex", gap:12, marginTop:4, justifyContent:"center" }}>
                  <button onClick={function(){ setIvs(ivs.map(function(iv){ return Object.assign({},iv,{_on:true}); })); }} style={{ background:"none", border:"none", color:"#6B7094", fontSize:11, ...FM, cursor:"pointer" }}>Enable All</button>
                  <button onClick={function(){ setIvs(ivs.map(function(iv){ return Object.assign({},iv,{_on:false}); })); }} style={{ background:"none", border:"none", color:"#6B7094", fontSize:11, ...FM, cursor:"pointer" }}>Disable All</button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* STEP 5 — INVITE CREW (Captain & Crew / Pro only) */}
        {step===5 && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", padding:"24px 24px 100px" }}>
            <PBar step={4} total={7} />
            <div style={{ marginTop:28, marginBottom:24 }}>
              <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:10 }}>Step 4 of 6</div>
              <div style={{ fontSize:24, fontWeight:700, lineHeight:1.2, marginBottom:8 }}>Invite your crew</div>
              <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.6 }}>Crew members log hours, submit service requests, and mark maintenance complete. Skip and add them later.</div>
            </div>
            {!hasCrew && (
              <div style={{ background:"rgba(155,114,208,0.1)", border:"1px solid #9B72D0", borderRadius:12, padding:"20px 18px", marginBottom:20 }}>
                <div style={{ fontSize:13, fontWeight:700, color:"#9B72D0", marginBottom:6 }}>Crew features require Captain & Crew or Pro</div>
                <div style={{ fontSize:12, color:"#9AA0C0", lineHeight:1.7 }}>Upgrade anytime from your account settings to add crew members and manage team permissions.</div>
              </div>
            )}
            <div style={{ flex:1, display:"flex", flexDirection:"column", gap:16 }}>
              {crew.length>0 && (
                <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                  {crew.map(function(c) {
                    return (
                      <div key={c.id} style={{ background:"rgba(76,175,110,0.1)", border:"1px solid #4CAF6E", borderRadius:10, padding:"10px 14px", display:"flex", alignItems:"center", gap:10 }}>
                        <div style={{ width:32, height:32, background:"#4CAF6E", borderRadius:8, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, fontWeight:700, color:"#0F1117", flexShrink:0 }}>{c.name.charAt(0).toUpperCase()}</div>
                        <div style={{ flex:1 }}>
                          <div style={{ fontSize:12, fontWeight:700 }}>{c.name}</div>
                          {c.email && <div style={{ fontSize:11, color:"#6B7094", marginTop:1 }}>{c.email}</div>}
                        </div>
                        <button onClick={function(){ setCrew(crew.filter(function(x){ return x.id!==c.id; })); }} style={{ background:"none", border:"none", color:"#6B7094", fontSize:18, cursor:"pointer", lineHeight:1 }}>x</button>
                      </div>
                    );
                  })}
                </div>
              )}
              <div style={{ background:"#1A1D27", border:"1px solid #2E3248", borderRadius:12, padding:16, display:"flex", flexDirection:"column", gap:12 }}>
                <div style={{ display:"flex", flexDirection:"column", gap:6 }}><label style={lbl}>Crew Member Name</label><input style={inp} placeholder="e.g. Tom W." value={cName} onChange={function(e){ setCName(e.target.value); }} /></div>
                <div style={{ display:"flex", flexDirection:"column", gap:6 }}><label style={lbl}>Username or Email (optional)</label><input style={inp} placeholder="tomw or tom@email.com" value={cEmail} onChange={function(e){ setCEmail(e.target.value); }} /></div>
                <button onClick={addCrew} disabled={!cName.trim()} style={{ background:cName.trim()?"rgba(245,166,35,0.1)":"#1E2230", border:"1px solid "+(cName.trim()?"#F5A623":"#2E3248"), borderRadius:10, color:cName.trim()?"#F5A623":"#6B7094", fontSize:12, ...FM, fontWeight:700, padding:11, cursor:cName.trim()?"pointer":"not-allowed", textTransform:"uppercase", letterSpacing:"0.08em" }}>+ Add Crew Member</button>
              </div>
              <Hint text="Crew see a simplified view. They can log entries, submit service requests, and mark maintenance done. They cannot edit equipment specs or see cost data." />
            </div>
          </div>
        )}

        {/* STEP 6 — TUTORIAL */}
        {step===6 && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", padding:"24px 24px 100px" }}>
            <PBar step={hasCrew?5:4} total={hasCrew?7:6} />
            <div style={{ marginTop:28, marginBottom:28 }}>
              <div style={{ fontSize:11, color:"#F5A623", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:10 }}>Step {hasCrew?"5":"4"} of {hasCrew?"6":"5"}</div>
              <div style={{ fontSize:24, fontWeight:700, lineHeight:1.2, marginBottom:8 }}>How ChoreHabit works</div>
              <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.6 }}>Four things to know. Swipe through or skip to your dashboard.</div>
            </div>
            <div style={{ flex:1, display:"flex", flexDirection:"column" }}>
              <div style={{ background:"#1A1D27", border:"1px solid #2E3248", borderRadius:16, padding:"32px 24px", marginBottom:20, flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", textAlign:"center" }}>
                <div style={{ width:72, height:72, background:"rgba(245,166,35,0.1)", borderRadius:16, display:"flex", alignItems:"center", justifyContent:"center", fontSize:36, marginBottom:20 }}>{TUTORIALS[slide].icon}</div>
                <div style={{ fontSize:18, fontWeight:700, color:TUTORIALS[slide].color, marginBottom:12 }}>{TUTORIALS[slide].title}</div>
                <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.7, maxWidth:320 }}>{TUTORIALS[slide].body}</div>
              </div>
              <div style={{ display:"flex", justifyContent:"center", gap:8, marginBottom:20 }}>
                {TUTORIALS.map(function(_,i) {
                  return <div key={i} onClick={function(){ setSlide(i); }} style={{ width:i===slide?24:8, height:8, borderRadius:4, background:i===slide?"#F5A623":"#2E3248", cursor:"pointer", transition:"width 0.3s" }} />;
                })}
              </div>
              <div style={{ display:"flex", gap:10 }}>
                {slide>0 ? <button onClick={function(){ setSlide(slide-1); }} style={{ flex:1, background:"none", border:"1px solid #2E3248", borderRadius:10, color:"#9AA0C0", fontSize:12, ...FM, padding:12, cursor:"pointer" }}>Back</button> : <div style={{ flex:1 }} />}
                {slide<TUTORIALS.length-1
                  ? <button onClick={function(){ setSlide(slide+1); }} style={{ flex:2, background:"#F5A623", border:"none", borderRadius:10, color:"#0F1117", fontSize:12, ...FM, fontWeight:700, padding:12, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>Next</button>
                  : <button onClick={next} style={{ flex:2, background:"#F5A623", border:"none", borderRadius:10, color:"#0F1117", fontSize:12, ...FM, fontWeight:700, padding:12, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>Got It</button>
                }
              </div>
            </div>
          </div>
        )}

        {/* STEP 7 — DONE */}
        {step===7 && (
          <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"40px 24px", textAlign:"center" }}>
            <PBar step={hasCrew?7:6} total={hasCrew?7:6} />
            <div style={{ marginTop:48 }}>
              <div style={{ fontSize:64, marginBottom:24 }}>{"🎉"}</div>
              <div style={{ fontSize:11, color:"#4CAF6E", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:700, marginBottom:12 }}>You're all set</div>
              <div style={{ fontSize:26, fontWeight:700, lineHeight:1.2, marginBottom:16 }}>{company?company+" is ready to roll":"Your fleet is ready to roll"}</div>
              <div style={{ fontSize:13, color:"#9AA0C0", lineHeight:1.7, marginBottom:40, maxWidth:320 }}>
                {totalEq>0?totalEq+" piece"+(totalEq!==1?"s":"")+" of equipment added. ":"Head to your dashboard to add equipment. "}
                {crew.length>0?crew.length+" crew member"+(crew.length>1?"s":"")+" ready to go. ":""}
                Your 30-day free trial has begun.
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8, marginBottom:40, width:"100%", maxWidth:360 }}>
                {[{l:"Equipment",v:String(totalEq),c:"#F5A623"},{l:"Intervals",v:String(totalIvs),c:"#4CAF6E"},{l:"Crew",v:String(crew.length),c:"#4A90D9"}].map(function(s) {
                  return (
                    <div key={s.l} style={{ background:"#1A1D27", border:"1px solid #2E3248", borderRadius:12, padding:"14px 8px" }}>
                      <div style={{ fontSize:24, fontWeight:700, color:s.c }}>{s.v}</div>
                      <div style={{ fontSize:10, color:"#6B7094", textTransform:"uppercase", letterSpacing:"0.08em", marginTop:3 }}>{s.l}</div>
                    </div>
                  );
                })}
              </div>
              <button onClick={finish} style={{ width:"100%", maxWidth:360, background:"#F5A623", border:"none", borderRadius:12, color:"#0F1117", fontSize:14, ...FM, fontWeight:700, padding:18, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.1em", boxShadow:"0 8px 24px rgba(245,166,35,0.3)" }}>Go to My Dashboard</button>
            </div>
          </div>
        )}

        {/* BOTTOM NAV */}
        {step>=2 && step<=5 && (
          <div style={{ position:"fixed", bottom:0, width:"100%", maxWidth:480, background:"#0F1117", borderTop:"1px solid #2E3248", padding:"12px 24px", display:"flex", gap:10, boxSizing:"border-box" }}>
            <button onClick={back} style={{ flex:1, background:"none", border:"1px solid #2E3248", borderRadius:10, color:"#9AA0C0", fontSize:12, ...FM, letterSpacing:"0.1em", textTransform:"uppercase", padding:13, cursor:"pointer" }}>Back</button>
            {step===2 && <button disabled={!company.trim()||!industry} onClick={next} style={{ flex:2, background:(company.trim()&&industry)?"#F5A623":"#1E2230", border:"none", borderRadius:10, color:(company.trim()&&industry)?"#0F1117":"#6B7094", fontSize:12, ...FM, fontWeight:700, padding:13, cursor:(company.trim()&&industry)?"pointer":"not-allowed", textTransform:"uppercase", letterSpacing:"0.1em" }}>Continue</button>}
            {step===3 && (
              <div style={{ flex:2, display:"flex", gap:8 }}>
                {!eqType&&fleet.length===0 && <button onClick={next} style={{ flex:1, background:"none", border:"1px solid #2E3248", borderRadius:10, color:"#6B7094", fontSize:11, ...FM, padding:13, cursor:"pointer" }}>Skip for Now</button>}
                {eqType&&eqName.trim() && <button onClick={saveAndAnother} style={{ flex:1, background:"#1E2230", border:"1px solid #2E3248", borderRadius:10, color:"#9AA0C0", fontSize:11, ...FM, fontWeight:700, padding:13, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.06em" }}>+ Add Another</button>}
                {(eqType&&eqName.trim()||fleet.length>0) && (
                  <button onClick={saveAndNext} style={{ flex:2, background:"#F5A623", border:"none", borderRadius:10, color:"#0F1117", fontSize:12, ...FM, fontWeight:700, padding:13, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>
                    {fleet.length>0&&!eqName.trim()?"Done ("+fleet.length+")":"Next"}
                  </button>
                )}
              </div>
            )}
            {step===4 && <button onClick={next} style={{ flex:2, background:"#F5A623", border:"none", borderRadius:10, color:"#0F1117", fontSize:12, ...FM, fontWeight:700, padding:13, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.1em" }}>Looks Good ({ivs.filter(function(iv){ return iv._on; }).length} intervals)</button>}
            {step===5 && (
              <div style={{ flex:2, display:"flex", gap:8 }}>
                <button onClick={next} style={{ flex:1, background:"none", border:"1px solid #2E3248", borderRadius:10, color:"#6B7094", fontSize:11, ...FM, padding:13, cursor:"pointer" }}>Skip</button>
                <button onClick={next} style={{ flex:2, background:"#F5A623", border:"none", borderRadius:10, color:"#0F1117", fontSize:12, ...FM, fontWeight:700, padding:13, cursor:"pointer", textTransform:"uppercase", letterSpacing:"0.08em" }}>{crew.length>0?"Continue":"Skip for Now"}</button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
